module.exports = {
  id: process.env.ANALYTICS_KEY
}
